import { useTranslate } from '../../../hooks';
import Core, { API_V2 } from '../../core';
import useGenericMutation from '../use-generic-mutation';
import { AxiosRequestConfig } from 'axios';

interface Props {
  url: string;
  params?: object;
  customInvalidateQueriesUrl?: string;
  msg?: string;
  axiosConfig?: AxiosRequestConfig<unknown>;
}

export const useCreate = ({
  url,
  params,
  customInvalidateQueriesUrl,
  msg,
  axiosConfig,
}: Props) => {
  const { translate } = useTranslate();
  const api = Core.getInstance().multipartFormData();

  return useGenericMutation({
    func: (data) => api.post(`${API_V2}/${url}`, data, axiosConfig),
    url,
    params,
    customInvalidateQueriesUrl,
    msg: msg ?? translate('created-successfully'),
  });
};
